import {UI} from "../../../stem-core/src/ui/UIBase";

import {styleRuleInherit} from "../../../stem-core/src/decorators/Style";
import {registerStyle} from "../../../stem-core/src/ui/style/Theme";
import {Banner, BannerStyle} from "./Banner";


export class ErrorBannerStyle extends BannerStyle {
    @styleRuleInherit
    toast = {
        background: this.themeProps.WALLET_ERROR_BACKGROUND,
    };
}

@registerStyle(ErrorBannerStyle)
export class ErrorBanner extends Banner {}
